import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

// 引入一键复制
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// 引入Mock
process.env.NODE_ENV == 'development' && require('@/mock/index')

// 引入字体
require('@/assets/fonts/font.css')

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
